import React from 'react';
import { useParams } from 'react-router-dom';
// import AvailableComponentLists from '../../utils/componentLists';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../header/Header';
import { Box, useDisclosure } from '@chakra-ui/react';
import CanvasCSSVariablesImport from './CanvasCSSVariablesImport';
import VisualizationModeComponent from './VisualizationMode';
import IconPackImport from './IconPackImport';
import GoogleFontLoader from 'react-google-font-loader';
import { createStandaloneToast, ChakraProvider } from '@chakra-ui/react';
import theme from '../../utils/ChakraTheme';

import './../../Canvas.scss';

import DragDropContextContainer from './DragDropContextContainer';

import PopoverEditComponent from '../popover/PopoverEditComponent';
import { customFonts, selectCustomFonts } from '../../redux/customFontsSlice';
import { visualizationMode } from '../../redux/visualizationModeSlice';
import { toggleMobile } from '../../redux/canvasResolutionSlice';
import ImagesImport from './ImagesImport';
import { getAuthHeader } from '../../utils/auth-token';

const Canvas = ({ userInfo }) => {
	const { viewId } = useParams();
	const dispatch = useDispatch();

	const toast = createStandaloneToast();
	const [error, setError] = React.useState();

	//criando state aqui para poder controlar o estilo do canvas
	const [leftDrawerIsOpen, setLeftDrawerIsOpen] = React.useState(false);
	const [rightDrawerIsOpen, setRightDrawerIsOpen] = React.useState(true);

	//20 commits mais recentes
	const [recentCommits, setRecentCommits] = React.useState([]); // lista com alterações
	const [recentCommitsLoaded, setRecentCommitsLoaded] = React.useState(false); //flag para validar se já terminou de carregar do bd as alterações
	const [recentCommitsIsOpen, setRecentCommitsIsOpen] = React.useState(false); //se o bloco de ver alterações está aberto

	//disclosure do modal de criar/editar projeto
	const { onOpen, onClose, isOpen } = useDisclosure();

	//modo de visualização
	const VMMode = useSelector(visualizationMode);

	//algumas das fontes default do io
	const fonts = useSelector(customFonts);

	//Debugger ->controla mostar ou não o campo com o JSON da página
	const [isDebugActive, setIsDebugActive] = React.useState(false);
	// const [isMobile,setIsMobile] = React.useState(false)

	React.useEffect(() => {
		dispatch(toggleMobile(1920));
	}, [VMMode]);

	// React.useEffect(() => {
	//     function checkUserData() {
	//         console.log("storage updated")
	//     }

	//     window.addEventListener('storage', checkUserData)

	//     return () => {
	//       window.removeEventListener('storage', checkUserData)
	//     }
	//   }, [])

	//Pegando apenas o customFonts
	React.useEffect(() => {
		fetch(`${process.env.REACT_APP_COMPILER_URL}/api/tachyons/getJSON/${viewId}`, { headers: getAuthHeader() })
			.then((resp) => resp.json())
			.then((resp) => {
				if (resp?.customFonts?.length) {
					dispatch(selectCustomFonts(resp.customFonts));
				}
			})
			.catch((e) => setError(e));
	}, []);

	React.useEffect(() => {
		if (error) {
			toast({
				title: `Ocorreu um erro ao buscar os estilos: ${error}`,
				status: 'error',
				duration: 10000,
				isClosable: true,
				position: 'top',
			});
		}
	}, [error]);
	return (
		<React.Fragment>
			<IconPackImport />
			<ImagesImport viewId={viewId} />
			{fonts?.length && (
				<GoogleFontLoader
					fonts={fonts.filter((f) => !['sans-serif', 'palatino', 'calibri'].includes(f.font.toLowerCase()))}
				/>
			)}
			<CanvasCSSVariablesImport {...{ viewId }} />
			<Header
				{...{
					isOpen,
					onOpen,
					onClose,
					viewId,
					userInfo,
					isDebugActive,
					setIsDebugActive,
					leftDrawerIsOpen,
					setLeftDrawerIsOpen,
				}}
			/>
			<Box
				transition={'0.2s'}
				d={'flex'}
				ml={0}
				mr={rightDrawerIsOpen ? '0' : '-215px'}
				justifyContent={'space-between'}
				pt={!visualizationMode ? '72px' : 0}
				h={'100%'}
				bg={'#EDF2F7'}
				className="DragDropContainerContext"
			>
				{VMMode ? (
					<VisualizationModeComponent {...{ viewId }} />
				) : (
					<DragDropContextContainer
						{...{
							viewId,
							userInfo,
							leftDrawerIsOpen,
							setLeftDrawerIsOpen,
							recentCommits,
							setRecentCommits,
							isDebugActive,
							recentCommitsIsOpen,
							setRecentCommitsIsOpen,
							recentCommitsLoaded,
						}}
					/>
				)}
				<ChakraProvider theme={theme} overflow={'hidden'} resetCSS={false}>
					<PopoverEditComponent />
				</ChakraProvider>
			</Box>
		</React.Fragment>
	);
};

export default Canvas;
Array.prototype.swap = function (indexA, indexB) {
	var element = this[indexA];
	this.splice(indexA, 1);
	this.splice(indexB, 0, element);
};
